import React from "react";
import {DIABLO_4} from "../../commons/enums/EiaEnums";
import D4EditAuctionDialog from "./game/D4EditAuctionDialog";

function EditAuctionDialog(props) {
    const {onClose, open, auction, game} = props;

    switch (game) {
        case DIABLO_4:
            return <D4EditAuctionDialog open={open} onClose={onClose} auction={auction}/>
        default:
            throw "Unsupported game" + game;
    }
}

export default EditAuctionDialog;